<script>
    import FormInput from '../../components/forms/FormInput.vue'
    export default {
        components: { FormInput },
        props: {
			formData: Object,
            errors: Object,
		},
        data() {
            return {}    
        }
    }
</script>
<template>
    <div class="card">
        <div class="card-title p-3 pt-2 mb-0" style="margin-bottom: -30px !important;">Additional Information</div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-lg-6 col-md-6 p-2 form-group">
                    <FormInput 
                        title="Facebook" 
                        v-model="formData.facebook"
                        :required="false"
                        :error="errors.facebook" 
                        type="text" 
                        name="facebook"
                    />
                </div>
                <div class="col-12 col-lg-6 col-md-6 p-2 form-group">
                    <FormInput 
                        title="Twitter" 
                        v-model="formData.twitter"
                        :required="false"
                        :error="errors.twitter" 
                        type="text" 
                        name="twitter"
                    />
                </div>
                <div class="col-12 col-lg-6 col-md-6 p-2 form-group">
                    <FormInput 
                        title="LinkedIn" 
                        v-model="formData.linkedin"
                        :required="false"
                        :error="errors.linkedin" 
                        type="text" 
                        name="linkedin"
                    />
                </div>
                <div class="col-12 col-lg-6 col-md-6 p-2 form-group">
                    <FormInput 
                        title="Website URL" 
                        v-model="formData.website"
                        :required="false"
                        :error="errors.website" 
                        type="text" 
                        name="website"
                    />
                </div>
            </div>
        </div>
    </div>
</template>